import { useState } from 'react';

import {
  type BaseModalFCProps,
  type ModalFC,
} from '@/components/modals/modalsManager';
import { Dialog } from '@/components/ui/dialog';
import { cn } from '@/lib/utils';

import { AgentInboxAddressForm } from './agent-inbox-address-form';
import { AgentInboxContacts } from './agent-inbox-contacts';
import { AgentInboxMailbox } from './agent-inbox-mailbox';
import { AgentInboxMessageDetail } from './agent-inbox-message-detail';
import { useAgentInboxAddressQuery } from './agent-inbox.query';

type View =
  | { name: 'mailbox' }
  | { name: 'message'; messageId: string }
  | { name: 'address' }
  | { name: 'contacts' };

export const AgentInboxModal: ModalFC<BaseModalFCProps> = ({
  open,
  onOpenChange,
}) => {
  const [view, setView] = useState<View>({ name: 'mailbox' });
  const { data: address } = useAgentInboxAddressQuery();
  const showMailbox = () => setView({ name: 'mailbox' });

  return (
    <Dialog.Root open={open} onOpenChange={onOpenChange}>
      <Dialog.Content
        className={cn(
          'flex max-h-[85vh] max-w-xl flex-col gap-0 overflow-hidden p-0',
          view.name !== 'address' && 'h-[40rem]'
        )}
        onOpenAutoFocus={(event) => event.preventDefault()}
      >
        {view.name === 'mailbox' && (
          <AgentInboxMailbox
            onOpenMessage={(messageId) =>
              setView({ name: 'message', messageId })
            }
            onChangeAddress={() => setView({ name: 'address' })}
            onOpenContacts={() => setView({ name: 'contacts' })}
          />
        )}
        {view.name === 'message' && (
          <AgentInboxMessageDetail
            messageId={view.messageId}
            onBack={showMailbox}
            onOpenChat={() => onOpenChange(false)}
          />
        )}
        {view.name === 'address' && address && (
          <AgentInboxAddressForm
            currentAddress={address}
            onDone={showMailbox}
          />
        )}
        {view.name === 'contacts' && (
          <AgentInboxContacts onBack={showMailbox} />
        )}
      </Dialog.Content>
    </Dialog.Root>
  );
};
